import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from "../../store";
import {getDictionaries, getLanguageDictionaries} from "../../api/translate.api";
Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: store.getters["auth/language"] || "en",
  fallbackLocale: 'en'
})

const loadedLanguages = Object.keys(sessionStorage);

function setI18nLanguage (lang) {
  i18n.locale = lang;
  return lang
}

export function loadDictionaries(defaultLanguage = i18n.locale) {
  getDictionaries().then(response => {
    const dictionaries = response.data;
    Object.keys(dictionaries).forEach(language => {
      sessionStorage.setItem(language, JSON.stringify(dictionaries[language]));
      loadedLanguages.push(language);
      i18n.setLocaleMessage(language, dictionaries[language]);
      if (defaultLanguage === language) {
        setI18nLanguage(language);
      }
    })
    store.dispatch("loader/hideLoadApp")
  })
}

export function loadLanguageAsync (defaultLanguage) {
  if (!defaultLanguage) {
    defaultLanguage = "en";
  }
  if (loadedLanguages.length) {
    loadedLanguages.forEach(language => {
      if(!language.includes('msal') && language.length == 2){
        const messages = JSON.parse(sessionStorage.getItem(language));
        i18n.setLocaleMessage(language, messages);
      }
    })
  }
  if (loadedLanguages.includes(defaultLanguage) && i18n.locale !== defaultLanguage) {
    setI18nLanguage(defaultLanguage)
    store.dispatch("loader/hideLoadApp")
  } else if (!loadedLanguages.includes(defaultLanguage)) {
     loadDictionaries(store.getters["auth/language"]);
  }
  return Promise.resolve()
}

export function getOneLanguageDictionary (lang) {
  getLanguageDictionaries(lang).then(
    (response)=>{
      sessionStorage.setItem(lang, JSON.stringify(response.data));
      i18n.setLocaleMessage(lang, response.data);
    }
  )
  return Promise.resolve()

}

